import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/products2/partners-providers/filter'; // Importing Filter component
import Table from 'views/partner/products2/partners-providers/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnersProvidersView class extends JetView to create a view for partner providers.
 */
export default class PartnersProvidersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            rows: [Filter, Table], // Layout containing Filter and Table components
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Check permissions for adding partner products
        if (!devConfig.getPermAction('partnerProducts2Providers', 'Add')) {
            this.show('./partner.products2.partnersSubProviders'); // Redirect if no permission
        } else {
            return {
                id: 'a5', // Unique identifier for the view
                type: 'clean', // Clean view type
                view: 'form', // Form view
                scroll: 'y', // Enable vertical scrolling
                rows: [
                    {
                        responsive: 'a5', // Responsive layout identifier
                        type: 'wide', // Wide layout type
                        cols: [left], // Columns containing the left layout
                    },
                ],
            };
        }
    }

    /**
     * Initializes the view. Currently empty.
     */
    init() {}
}

// FILE DOCUMENTED
